export default "__VITE_ASSET__34FXIqUu__"